function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i",
  x: 2.917,
  y: 0.077881,
  width: 6.0402,
  height: 16.718,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 17.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i",
  x: 8.9893,
  y: -3.9788,
  width: 4.8121,
  height: 12.892,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: -9
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-204.53 -107.07)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.26458 0 0 .26458 182.74 99.1)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(46.76 -5.1174)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(32.78 39.236)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2.8418 16.932 0.12701-0.1778 6.0071-11.398 0.01268-0.12067-2.648-4.974c-0.22197-0.41665-0.84658-0.31129-0.91933 0.15514z",
  fill: "#ffc24a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m2.917 16.796 0.09603-0.1873 5.9442-11.279-2.6414-4.9942c-0.21951-0.41228-0.777-0.30716-0.84903 0.15436z",
  fill: "#ffa712"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2.917 16.796 0.09603-0.1873 5.9442-11.279-2.6414-4.9942c-0.21951-0.41228-0.777-0.30716-0.84903 0.15436z",
  fill: "#fcca3f",
  fillOpacity: 0.87
})), /*#__PURE__*/React.createElement("path", {
  d: "m10.919 8.997 1.9716-2.0192-1.9722-3.765c-0.1872-0.3564-0.71-0.35747-0.8952 0l-1.0538 2.0095v0.17111l1.9495 3.6037z",
  fill: "#f4bd62"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.884 8.9129 1.9169-1.9631-1.9169-3.65c-0.182-0.34647-0.6242-0.38279-0.8043-0.0353l-1.0592 2.0407-0.03171 0.10434z",
  fill: "#ffa50e"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.884 8.9129 1.9169-1.9631-1.9169-3.65c-0.182-0.34647-0.6242-0.38279-0.8043-0.0353l-1.0592 2.0407-0.03171 0.10434z",
  fill: "#fcca3f",
  fillOpacity: 0.87
})), /*#__PURE__*/React.createElement("path", {
  d: "m2.8418 16.932 0.05755-0.0579 0.20916-0.085 7.6867-7.6581 0.0974-0.2651-1.9176-3.654z",
  fill: "#f6820c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.165 20.794 6.9566-3.8797-1.9866-12.235c-0.0621-0.38279-0.5317-0.5341-0.8057-0.25966l-12.488 12.512 6.9167 3.8618c0.215 0.12 0.45709 0.1831 0.70339 0.1831 0.2462 1e-4 0.4883-0.0629 0.7034-0.1828z",
  fill: "#fde068"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.06 16.881-1.9715-12.142c-0.0616-0.37991-0.4521-0.53708-0.7241-0.26468l-12.445 12.433 6.8408 3.8235c0.21335 0.1191 0.45366 0.1817 0.69796 0.1818 0.2444 0 0.4847-0.0624 0.6981-0.1814l6.9038-3.8503z",
  fill: "#fcca3f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.165 20.679c-0.2151 0.1199-0.4572 0.1829-0.7034 0.1828-0.2462 0-0.48836-0.0631-0.70334-0.1831l-6.861-3.8063-0.05564 0.0588 6.9167 3.8618c0.21499 0.1201 0.45714 0.1831 0.70334 0.1832 0.2462 0 0.4884-0.0629 0.7034-0.1829l6.9566-3.8797-0.017-0.1048-6.9396 3.8703z",
  fill: "#eeab37"
})))));

function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.0429mm",
    height: "6.6027mm",
    viewBox: "0 0 4.0429 6.6027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.84e3a2cb.svg";
export { ForwardRef as ReactComponent };